
import { BookOpenCheck, Calendar, FileText, ShoppingCart } from 'lucide-react'
import { MdOutlineCategory } from 'react-icons/md'
import { DetailsComponent } from '../../details/details.component'
import { PaymentComponent } from '../../payment/payment.component'
import { CatalogComponent } from '../../catalog/catalog.component'
import { CartComponent } from '../../cart/cart.component'
import { SummaryComponent } from '../../summary/summary.component'

export const ORDER_FORM_TAB_ITEMS = [
	{
		id: 1,
		textTab: 'Dados',
		icon: FileText,
	},
	{
		id: 2,
		textTab: 'Prazo',
		icon: Calendar,
	},
	{
		id: 3,
		textTab: 'Itens',
		icon: MdOutlineCategory,
	},
	{
		id: 4,
		textTab: 'Carrinho',
		icon: ShoppingCart,
	},
	{
		id: 5,
		textTab: 'Finalizar',
		icon: BookOpenCheck,
	},
]


export const ORDER_FORM_TAB_PANELS = [
	{
		id: '1',
		text: 'Dados',
		component: DetailsComponent,
	},
	{
		id: '2',
		text: 'Prazo',
		component: PaymentComponent,
	},
	{
		id: '3',
		text: 'Itens',
		component: CatalogComponent,
	},
	{
		id: '4',
		text: 'Carrinho',
		component: CartComponent,
	},
	{
		id: '5',
		text: 'Finalizar',
		component: SummaryComponent,
	},
]
